import { useState, useCallback } from 'react'
import VirtualScroll from "react-dynamic-virtual-scroll";
import { IDropDownItem } from 'interfaces/IDropDown'

// components
import Icon from '../Icon'

import {
  Wrapper,
  Header,
  Body,
  Item
} from './styles'

interface Props {
  items: IDropDownItem[];
  title: string;
  activeId: number;
  setActiveId: (id: number) => void;
}

export default function DropDown({ items, title, activeId = -1, setActiveId }: Props) {

  const [isOpen, setIsOpen] = useState(false)

  const renderItem = useCallback((rowIndex: any) => {
    return (
      <Item onClick={() => setActiveId(activeId)}>
        {items[rowIndex].icon && <Icon style={{width: '1.8rem', height: '1.8rem', display: 'flex'}} name={items[rowIndex]?.icon} />}
        {items[rowIndex].title}
      </Item>
    );
  }, []);

  return (
    <Wrapper>

      <Header
        onClick={() => setIsOpen(!isOpen)}
        className={isOpen ? 'active' : null}
      >
        {activeId !== -1
          ? <>{items[activeId].title}</>
          : <>{title}</>
        }
      </Header>
      <Body className={isOpen ? 'active' : null}>

        <VirtualScroll
          className="List"
          minItemHeight={40}
          totalLength={items.length}
          renderItem={renderItem}
        />

      </Body>

    </Wrapper>
  );
}